import { useFormikContext } from 'formik'
import { BaseInputWrapperProps } from '~/@/components/inputs/base/types'
import { Dropdown } from '~/@/components/inputs/selection/dropdown'
import { useGetActiveUsersQuery } from '~/common/generated/apollo-operations'
import { CellValue } from '../add-record/AddRecordDialog'
import { useRecordDetailsCellPermissions } from '../RecordDetailsCellPermissionsProvider'
import { RecordDetailTableCellUser } from '../types'

interface UserCellDetailsProps {
  fieldName: string
  value: CellValue
  inputWrapperProps?: BaseInputWrapperProps
}

export function UserCellDetails({ fieldName, value, inputWrapperProps }: UserCellDetailsProps) {
  const formik = useFormikContext<Record<string, RecordDetailTableCellUser[] | null>>()
  const { data } = useGetActiveUsersQuery()
  const { isReadOnly } = useRecordDetailsCellPermissions()
  const users = data?.activeUsers ?? []

  let cellValue: RecordDetailTableCellUser | undefined = undefined
  if (Array.isArray(value) && value.length > 0) {
    const firstValue = value[0]
    if (typeof firstValue === 'object' && 'firstName' in firstValue) {
      cellValue = firstValue
    }
  }

  return (
    <Dropdown
      disabled={isReadOnly}
      onChange={(selectedValue) => {
        formik.setFieldTouched(fieldName, true)
        if (!selectedValue) {
          formik.setFieldValue(fieldName, null)
        } else {
          const selectedUser = users.find((user) => user.id === selectedValue)
          formik.setFieldValue(fieldName, selectedUser ? [selectedUser] : null)
        }
      }}
      options={users.map((user) => ({
        label: `${user.firstName} ${user.lastName}`,
        value: user.id,
      }))}
      placeholder="Select user"
      showClearButton={!inputWrapperProps?.required}
      value={cellValue?.id}
      {...inputWrapperProps}
    />
  )
}
